import { Component, createEffect, createSignal, on } from 'solid-js'
import './style/bool.scss'

type Props = {
    default: boolean
    onChange(value: boolean): void
}
export const CompBool: Component<Props> = P => {
    const [value, setValue] = createSignal<boolean>(P.default || false)

    createEffect(
        on(
            () => P.default,
            p => setValue(p)
        )
    )

    function toggle() {
        P.onChange(setValue(s => !s))
    }

    return (
        <div
            class='input-flags-bool'
            classList={{ active: value() }}
            onClick={toggle}
        >
            <div class='circle'></div>
        </div>
    )
}
